import { Location } from "history";

export const splitPathOnLastPart = (location: Location): [string, string] => {
    const path = location.pathname;
    const index = path.lastIndexOf("/");
    return [path.slice(0, index), path.slice(index)];
};
